module.exports = __webpack_public_path__ + "static/media/clothes-1.bcca488d.jpg";